export const initialState = [
    {
        id: 1,
        text: "beaf meat",
        completed: true,
    },
    {
        id: 2,
        text: "Cat Fish",
        completed: false,
        color: "red",
    },
];
